import {type Static, Type} from '@sinclair/typebox'
import {TypeCompiler} from '@sinclair/typebox/compiler'

import {type Product, transformProducts} from '@/models/productModel'

const rawSearchResultSchema = Type.Object({
  metadata: Type.Object({
    thread_id: Type.Optional(Type.String()),
  }),
  products: Type.Array(Type.Unknown()), // to be validated later
  suggested_prompts: Type.Optional(Type.Array(Type.String())),
})

export type RawSearchResult = Static<typeof rawSearchResultSchema>

const rawSearchResultTypeCheck = TypeCompiler.Compile(rawSearchResultSchema)

export interface SearchResult {
  thread_id?: string
  products: Product[]
  suggestedPrompts?: string[]
}

export function transformSearchResult(searchResult: unknown) {
  if (!rawSearchResultTypeCheck.Check(searchResult)) {
    console.error(
      'Invalid search result: ',
      searchResult,
      ...rawSearchResultTypeCheck.Errors(searchResult),
    )
    return false as const
  }

  return {
    thread_id: searchResult.metadata.thread_id,
    products: transformProducts(searchResult.products),
    suggestedPrompts: searchResult.suggested_prompts,
  }
}
